import React, { useState, useEffect } from 'react';
import Icon, { COLORS, ICONS } from './icon';

//this is its own functional component to prevent re-rendering a redux component every second

export default function Clock() {
	const [currentTime, setCurrentTime] = useState(new Date());
	let clockInterval: NodeJS.Timeout;

	const updateClock = () => {
		clockInterval = setInterval(() => {
			setCurrentTime(new Date());
		}, 1000)
	}

	useEffect(() => {
		updateClock();
		return () => { clearInterval(clockInterval); }
	}, [])


	return (
		<div className="clock">
			<p className="header-time">
				<Icon name={ICONS.CLOCK} color={COLORS.WHITE} size={14} />
				{currentTime.toLocaleString("en-US", { hour: 'numeric', minute: 'numeric', second: 'numeric' })}
			</p>
		</div>

	)
}